<div class="online" [style.background]="isOnLine() ? '#008A00' : '#D50000'"></div>

<app-loader></app-loader>

<main class="app">
  <app-navbar></app-navbar>

  <router-outlet />

  <app-footer></app-footer>
</main>
